module.exports = __webpack_public_path__ + "img/slide04.2138a609.jpg";